import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class NoAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { onBackClicked } = this.props;

        return (<>

            <h2>Sorry...</h2>

            <p className="subtitle">
                It looks like you live between our sweeps.<br />
                <br />
                Your enquiry will be passed to Wilkins Chimney Sweep Head Office<br />
                <br />
                We'll get back to you quickly!
            </p>

            <div className="nav-buttons">

                <button
                    type="button"
                    className="btn me-auto"
                    onClick={() => onBackClicked()}
                >
                    Go Back
                </button>

            </div>

        </>);
    }
    
}

export default NoAccount;